/** Same key as settingsService.saveNotifications — drives admin header bell feed */
export const ADMIN_NOTIFICATION_SETTINGS_KEY = 'sheenwear_notification_settings';

const DEFAULTS = {
  orderNotifications: true,
  stockNotifications: true,
  userNotifications: true,
};

/**
 * Which feed rows to show in the admin bell (Order / Stock / User).
 * Missing keys default to true so older localStorage / partial API payloads still work.
 */
export function readAdminNotificationFeedPrefs() {
  try {
    const s = localStorage.getItem(ADMIN_NOTIFICATION_SETTINGS_KEY);
    if (!s) return { ...DEFAULTS };
    const o = JSON.parse(s);
    if (!o || typeof o !== 'object') return { ...DEFAULTS };
    return {
      orderNotifications: o.orderNotifications !== false,
      stockNotifications: o.stockNotifications !== false,
      userNotifications: o.userNotifications !== false,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export const ADMIN_NOTIFICATION_FEED_PREFS_CHANGED = 'adminNotificationFeedPrefsChanged';
